import Select from "../../Select";
import Button from "../../Button";
import React from "react";
import styles from "./SurveyForm.module.scss";
import { useFormik } from "formik";
import * as yup from "yup";
import FormPolicy from "../FormPolicy";

const validationSchema = yup.object({
  email: yup.string().email().required("Email is required"),
  fullName: yup.string().required("Full Name is required"),
  website: yup
    .string()
    .matches(/^[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, "Please enter a valid URL")
    .required("Website is required"),
  position: yup.string().required("Position is required"),
});

const SurveyForm = ({
  submitHandler,
  submitting,
  variant = "submit",
  className,
}) => {
  const onSubmit = (values) => {
    submitHandler(values);
    formik.resetForm();
  };

  const buttonText =
    variant === "submit" ? "Select a Date & Time" : "Get the checklist";

  const formik = useFormik({
    initialValues: {
      email: "",
      fullName: "",
      position: "",
      website: "",
    },
    validateOnChange: false,
    onSubmit,
    validationSchema,
  });

  return (
    <form
      className={`${styles.root} ${styles.form} ${
        variant === "checklist" && styles.root_checklist
      } ${className}`}
      onSubmit={formik.handleSubmit}
    >
      <div className={styles.item}>
        <label>Full Name</label>
        <input
          type="text"
          name="fullName"
          className={`${styles.input} ${
            formik.touched.fullName && formik.errors.fullName && styles.error
          }`}
          placeholder="Full Name"
          value={formik.values.fullName}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
        />
        {formik.touched.fullName && formik.errors.fullName && (
          <div className={styles.errorMessage}>{formik.errors.fullName}</div>
        )}
      </div>
      <div className={styles.item}>
        <label>Work Email</label>
        <input
          type="email"
          name="email"
          className={`${styles.input} ${
            formik.touched.email && formik.errors.email && styles.error
          }`}
          placeholder="Work Email"
          value={formik.values.email}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
        />
        {formik.touched.email && formik.errors.email && (
          <div className={styles.errorMessage}>{formik.errors.email}</div>
        )}
      </div>
      <div className={styles.item}>
        <label>App URL/Company Website</label>
        <input
          type="text"
          name="website"
          className={`${styles.input} ${
            formik.touched.website && formik.errors.website && styles.error
          }`}
          placeholder="App URL/Company Website"
          value={formik.values.website}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
        />
        {formik.touched.website && formik.errors.website && (
          <div className={styles.errorMessage}>{formik.errors.website}</div>
        )}
      </div>
      <div className={styles.item}>
        <label>Position</label>
        <Select
          formik={formik}
          name="position"
          value={
            formik.values.position
              ? {
                  value: formik.values.position,
                  label: formik.values.position,
                }
              : ""
          }
          options={[
            { value: "CEO/Founder", label: "CEO/Founder" },
            { value: "Product Manager", label: "Product Manager" },
            { value: "Marketing Manager", label: "Marketing Manager" },
            { value: "Developer", label: "Developer" },
            { value: "Data Analyst", label: "Data Analyst" },
            { value: "Other", label: "Other" },
          ]}
        />
      </div>
      <div className={`${styles.item} ${styles.actions}`}>
        <Button
          id="get-demo-btn-1"
          title={submitting === 2 ? "Sent!" : buttonText}
          type="submit"
          disabled={submitting > 0}
        />
      </div>

      {variant === "checklist" && <FormPolicy />}
    </form>
  );
};

export default SurveyForm;
